<m-overlay :open="isOverlayOpen">
  <template #header>
    <h2>
      {{ $i18next.t('modules.fiche-repondant.FicheRepondantConditionsOverlay.title') }}
    </h2>
  </template>
  <template #footer>
    <m-button
      :skin="MButtonSkin.Secondary"
      @click="onHideOverlayButtonClick"
    >
      {{ $i18next.t('modules.fiche-repondant.FicheRepondantConditionsOverlay.footer.close.label') }}
    </m-button>
  </template>
  <p v-html="$i18next.t('modules.fiche-repondant.FicheRepondantConditionsOverlay.content', { userFullName })" />
</m-overlay>